<template>
  <ion-page>
    <master-layout pageTitle="ویرایش اطلاعات مدیر">
      <ion-card>
        <ion-card-content>
          <Loading :is="!customerLoaded" v-if="!customerLoaded"></Loading>
          <div v-if="customerLoaded">
            <div v-if="customer">
              <AjaxForm route="admin/Edit">
                <input class="" type="hidden" name="admin_id" :value="customer._id">

                <div class="mb-2">
                  <label>نام کامل</label>
                  <input type="text"  name="fullname" class="form-control" :value="customer.fullname">
                </div>

                <div class="mb-2">
                  <label>نام کاربری</label>
                  <input type="text"  name="username" class="form-control" :value="customer.username">
                </div>

                <div class="mb-2">
                  <label>تلفن همراه</label>
                  <input type="tel" name="phone" class="form-control" :value="customer.phone">
                </div>

                <div class="mb-2">
                  <label>کد ملی</label>
                  <input type="text" name="national_code" class="form-control" :value="customer.national_code">
                </div>

                <div class="mb-2">
                  <label>ایمیل</label>
                  <input name="email" type="email" class="form-control" :value="customer.email">
                </div>

<!--                <div class="mb-2">-->
<!--                  <label>نقش کاربری</label>-->
<!--                  <select name="role_id" class="form-control">-->
<!--                    <option :selected="(customer.role_id && customer.role_id===item._id)" v-for="(item,index) in roles" :key="index" :value="item._id">{{item.title}}</option>-->
<!--                  </select>-->
<!--                </div>-->

                <button class="btn btn-block btn-lg btn-success mt-2" type="submit">
                  ویرایش اطلاعات مدیر <i class="fas fa-plus"></i>
                </button>

              </AjaxForm>
            </div>
            <div v-if="error" class="alert alert-danger">
              {{error}}
            </div>
          </div>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import {mapActions} from "vuex";
// import {showSystemNoti} from '@/shared/helper'
import {IonPage,IonCard,IonCardContent,IonCardHeader} from '@ionic/vue';
import AjaxForm from "@/components/AjaxForm";

// import {getFormData} from '@/shared/helper'

export default {
  name: "Addcustomer",
  components: {
    AjaxForm,
    IonPage,IonCard,IonCardContent,IonCardHeader
  },
  data()
  {
    return {
      id:null,
      customerLoaded: false,
      customer:null,
      error:null,
      roles : []
    }
  },
  async created()
  {
    this.id = this.$route.params.id;
    const result = await this.getAdmin(this.id);
    if (result)
    {
      if (result.ok)
      {
        this.customerLoaded = true;
        this.customer = result.admin;
      }
      else
      {
        this.customerLoaded = true;
        this.error = result.error
      }
    }
    else
    {
      this.customerLoaded = true;
      this.error = 'خطا در برقراری ارتباط با سرور'
    }
  },
  methods: {
    ...mapActions("admin", {
      getAdmin: 'getAdmin',
    }),
  }
}

</script>

<style scoped>

</style>